<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import FontSelector from './PreviewEditor/FontSelector.svelte';
  import TextColor from './PreviewEditor/TextColor.svelte';
  import {events} from './RemotionElements/Util';
  import FontList from './PreviewEditor/FontList.svelte';
  import Logo from './PreviewEditor/Logo.svelte';
  import Layers from './PreviewEditor/Layers.svelte';

  let isSideBarPopUpOpen = false;

  function openSidebarPopup() {
    isSideBarPopUpOpen = true;
  }

  function closeSideBarPopup() {
    isSideBarPopUpOpen = false;
  }

  onMount(() => {
    window.addEventListener(events.sideBarPopUpOpen, openSidebarPopup);
    window.addEventListener(events.sideBarPopUpClose, closeSideBarPopup);
  });

  onDestroy(() => {
    window.removeEventListener(events.sideBarPopUpOpen, openSidebarPopup);
    window.removeEventListener(events.sideBarPopUpClose, closeSideBarPopup);
  });
</script>

<div
  class="relative z-30 flex h-full flex-col gap-4 overflow-hidden border-r border-gray-300 shadow-md"
  style="min-width: 480px;"
>
  <div class="flex h-full flex-col overflow-y-scroll px-5" id="sidebarContent">
    <div class="w-full">
      <div class="flex items-center gap-1 pb-2 pb-6 pt-8 font-bold text-zinc-900">
        <h1 class="text-2xl">Quick Edit</h1>
      </div>
      <div class="w-full">
        <TextColor />
        <FontSelector />
        <Logo />
      </div>
      <hr />
      <div class="flex items-center gap-1 pb-2 pb-6 pt-8 font-bold text-zinc-900">
        <h1 class="text-2xl">Advance Edit</h1>
      </div>
      <Layers />
    </div>
  </div>
  {#if isSideBarPopUpOpen}
    <div class="absolute top-0 h-full w-full border-r bg-white" style="max-width: 420px;">
      <FontList />
    </div>
  {/if}
</div>
